import { push } from "react-router-redux";
import { stopSubmit } from "redux-form";
import api from "../services/api";

export const GET_QUESTIONS_SUCCESS = "GET_QUESTIONS_SUCCESS";
export const CHECK_STATE_START = "CHECK_STATE_START";
export const CHECK_STATE_SUCCESS = "CHECK_STATE_SUCCESS";
export const CHECK_STATE_ERROR = "CHECK_STATE_ERROR";
export const GET_REFERENCE_SUCCESS = "GET_REFERENCE_SUCCESS";
export const DECLINE_REFERENCE_SUCCESS = "DECLINE_REFERENCE_SUCCESS";
export const CREATE_REFERENCE_SUCCESS = "CREATE_REFERENCE_SUCCESS";

export const WORK_REFERENCE_FORM = "workReference";

export function onGetQuestionsSuccess(data) {
  return {
    type: GET_QUESTIONS_SUCCESS,
    data
  };
}

export function onCheckStateStart() {
  return {
    type: CHECK_STATE_START
  };
}

export function onCheckStateSuccess(data) {
  return {
    type: CHECK_STATE_SUCCESS,
    data
  };
}

export function onCheckStateError() {
  return {
    type: CHECK_STATE_ERROR
  };
}

export function onGetReferenceSuccess(data) {
  return {
    type: GET_REFERENCE_SUCCESS,
    data
  };
}

export function onDeclineReferenceSuccess() {
  return {
    type: DECLINE_REFERENCE_SUCCESS
  };
}

export function onCreateReferenceSuccess() {
  return {
    type: CREATE_REFERENCE_SUCCESS
  };
}

export function getQuestions() {
  return dispatch => {
    api
      .getQuestions()
      .then(res => {
        dispatch(onGetQuestionsSuccess(res.data));
      })
      .catch(() => {});
  };
}

export function checkState(referenceId) {
  const payload = {
    reference_id: referenceId
  };
  return dispatch => {
    dispatch(onCheckStateStart());
    api
      .checkState(payload)
      .then(res => {
        dispatch(onCheckStateSuccess(res.data));
      })
      .catch(() => {
        dispatch(onCheckStateError());
      });
  };
}

export function getReference(referenceId) {
  return dispatch => {
    api
      .getReference(referenceId)
      .then(res => {
        dispatch(onGetReferenceSuccess(res.data));
      })
      .catch(() => {});
  };
}

export function declineReference(referenceId) {
  const payload = {
    reference_id: referenceId,
    declined: true
  };
  return dispatch => {
    api
      .declineReference(payload)
      .then(() => {
        dispatch(onDeclineReferenceSuccess());
        dispatch(push("reference/confirmation"));
      })
      .catch(error => {
        dispatch(stopSubmit(WORK_REFERENCE_FORM, error.response.data.errors));
      });
  };
}

export function createReference(data) {
  return dispatch => {
    api
      .createReference(data)
      .then(() => {
        dispatch(onCreateReferenceSuccess());
        dispatch(push("reference/confirmation"));
      })
      .catch(error => {
        dispatch(stopSubmit(WORK_REFERENCE_FORM, error.response.data.errors));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/workReferences.actions.js